import ContentContainer from "layout/Content/ContentContainer";
import ViewConversation from "pages/MessageBox/ViewConversation";
import TopBanner from "layout/TopBanner/TopBanner";
import ImageHero from "pages/Profile/assets/hero-leden-zoeken.png?v2";
import Button from "components/ui/Button/Button";
import { ReactComponent as IconPencil } from "assets/images/icons/pencil-square.svg";
import { useDialog } from "context/DialogContext";
import MessageCreate from "pages/MessageBox/MessageCreate";
import useEntity from "hooks/useEntity";
import ViewConversations from "pages/MessageBox/ViewConversations";
import { useEffect, useRef } from "react";
import { ReactComponent as IconArrowBack } from "assets/images/icons/arrow-left-short.svg";
import { useMessageBox } from "pages/MessageBox/MessageBoxContext";
import { useQuery } from "hooks/useQuery";
import { useAccount } from "context/AccountContext";

function MessageBoxContent() {
  const { showDialog } = useDialog();
  const { user } = useAccount();
  const query = useQuery();
  const contentPanelRef = useRef();

  const { entity } = useEntity(window.location.pathname, 'page');
  const {
    conversations,
    refreshConversations,
    selectedConversation,
    setSelectedConversation,
    filter
  } = useMessageBox();

  const isVisible = (element) => {
    const style = getComputedStyle(element);
    return style.display === 'block';
  }

  const selectFirst = () => {
    const firstRow = conversations?.results && conversations.results[0];
    if (!firstRow) {
      return;
    }

    let partnerId = parseInt(firstRow.sender_uid);
    if (partnerId === user.id) {
      partnerId = firstRow.receiver_uid;
    }

    selectConversation(partnerId)
  }

  const selectConversation = userId => {
    setSelectedConversation(() => userId);
  }

  useEffect(() => {
      if (query.get('user_id')) {
        setSelectedConversation(query.get('user_id'));
      } else if (!selectedConversation && !filter && isVisible(contentPanelRef.current)) {
        selectFirst();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ conversations ]
  );

  const onCompletedNewMessage = receiver => {
    setSelectedConversation(receiver);
    if (!conversations.results.find(element => parseInt(element.receiver_uid) === parseInt(receiver))) {
      refreshConversations();
    }
  }

  return (
    <>
      <TopBanner title={ entity?.title?.value }
                 intro={ entity?.field_intro?.value }
                 image={ ImageHero }
                 hideBottomActions={ true }>
        <Button variant={ `secondary` }
                onClick={ () => showDialog(<MessageCreate onCompleted={ onCompletedNewMessage }/>) }>
          <IconPencil/>
          Nieuw bericht
        </Button>
      </TopBanner>

      <ContentContainer contentBackground={ true }
                        contentGridType={ 'wide' }
                        contentPadding={ true }>
        <div
          className={ `messages-overview ${ selectedConversation ? 'messages-overview--with-selected-conversation' : '' }` }>
          <div className={ `messages-overview__menu` }>
            <ViewConversations/>
          </div>
          <div className={ `messages-overview__content` } ref={ contentPanelRef }>
            {
              selectedConversation &&
              <>
                <Button variant={ `ghost` }
                        className={ `button--small messages-overview__close-conversation` }
                        onClick={ () => setSelectedConversation(null) }>
                  <IconArrowBack/>
                  Andere gesprekken
                </Button>

                <ViewConversation/>
              </>
            }
          </div>
        </div>
      </ContentContainer>
    </>
  );
}

export default MessageBoxContent;
